import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, PropType } from "vue";
import { LineTypeCode } from "@/types";
import {
  IFullSeatLineTurn,
  ILineSet,
  ITurn,
  ITurnLite,
} from "@/domain/entities/lineInfo";
import useGetEarlyDriveWeekdays from "@/use/useGetEarlyDriveWeekdays";
import { useLineTypeChipClass } from "@/composables/line/useLineTypeChipClass";
import { useLineSetMap } from "@/composables/line/useLineSetMap";
import { useDriveDatesItems } from "@/composables/line/useDriveDatesItems";


const __default__ = {
  name: "LineSetTypeChip",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineTypeCode: {
    type: String as PropType<LineTypeCode>,
    required: true,
  },
  lineTypeName: {
    type: String,
    required: true,
  },
  lineTurns: {
    type: Array as PropType<ITurn[] | IFullSeatLineTurn[] | ITurnLite[]>,
    default: () => [],
  },
  isSmallSize: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideDayOfWeek: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const computedLineTypeCode = computed(() => props.lineTypeCode);
const { lineTypeClass } = useLineTypeChipClass(computedLineTypeCode);

const { lineSetMap, updateLineSetMap } = useLineSetMap();

const lineSets = computed(() =>
  Array.from(lineSetMap.value).map((lineSet: [string, ILineSet]) => lineSet[1])
);
const batchUpdateLineSetMap = (
  turns: ITurn[] | IFullSeatLineTurn[] | ITurnLite[]
) => {
  for (const turn of turns) {
    updateLineSetMap(turn.lineSets);
  }
};

const earlyDriveInfosList = computed(() =>
  useGetEarlyDriveWeekdays(props.lineTurns)
);

const { driveDatesItems } = useDriveDatesItems(earlyDriveInfosList);

onMounted(() => {
  batchUpdateLineSetMap(props.lineTurns);
});

const __returned__ = { props, computedLineTypeCode, lineTypeClass, lineSetMap, updateLineSetMap, lineSets, batchUpdateLineSetMap, earlyDriveInfosList, driveDatesItems }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})